import { Skeleton } from '@dixa/lib-shared-habla';
import { MetricInstrumentData } from 'lib-analytics-ui';
import { ResponseTimeMetric } from 'lib-dashboard-types';
import { PropsWithClassName } from 'lib-shared-types-utils';
import { memo } from 'react';

import { QueueDashboardMetric } from 'app/views/layout/views/dashboard/views/queue/components/queues/components/metric';

import { useQueueDashboardQueueContext } from '../../../../../queue/queueDashboardQueue.context';

type QueueDashboardAverageResponseTimeMetricProps = {
  metric?: ResponseTimeMetric;
} & PropsWithClassName;

export const QueueDashboardAverageResponseTimeMetric = memo(
  function QueueDashboardAverageResponseTimeMetric({
    className,
    metric,
  }: QueueDashboardAverageResponseTimeMetricProps): JSX.Element {
    const { isSkeleton } = useQueueDashboardQueueContext();

    return (
      <QueueDashboardMetric
        className={className}
        metricType="response_time"
        isSkeleton={isSkeleton}
      >
        {isSkeleton ? (
          <Skeleton height="24px" width="72px" />
        ) : (
          <MetricInstrumentData
            data={metric?.average_response_time ?? null}
            format="duration"
          />
        )}
      </QueueDashboardMetric>
    );
  },
);
